import WestoreAuth from "@/services/westore/auth";
import router from "@/router";
import i18n from "../../i18n";

export const state = () => ({
  user: JSON.parse(localStorage.getItem("user")),
  meta: JSON.parse(localStorage.getItem("meta")),
  csrf: false,
});

export const getters = {
  authenticated(state) {
    return !!state.user;
  },
  bearer_token(state) {
    if (state.user) {
      return `Bearer ${state.user.token}`;
    }

    return null;
  },
  verified(state) {
    return state.meta.account.verified;
  },
  verificationMessage(state) {
    return state.meta.account.email.message;
  },
  services({ meta }) {
    if (meta) {
      return meta.services;
    }
  },
  userCountry({ meta }) {
    if (meta) {
      return meta.country;
    }
  },
  account({ meta }) {
    if (meta) {
      return meta.account;
    }
  },
  userPermission({ user }) {
    if (user) {
      return user.contracted;
    }
  },
  freight({ user }) {
    if (user) {
      return user.freight;
    }
  },
  lang({ user }) {
    return user?.locale;
  },
  userInfo({ user }) {
    return user;
  },
};

export const mutations = {
  SET_USER(state, value) {
    state.user = value;
    value
      ? localStorage.setItem("user", JSON.stringify(value))
      : localStorage.removeItem("user");
  },
  SET_META(state, value) {
    state.meta = value;
    value
      ? localStorage.setItem("meta", JSON.stringify(value))
      : localStorage.removeItem("meta");
  },
  SET_CSRF(state, value) {
    state.csrf = value;
  },
  CHANGE_LANG(state, lang) {
    i18n.locale = lang;
    const bootstrapRtlStyleId = "bootstrap-style";
    const appRtlStyleId = "app-style";
    if (["ar"].includes(lang)) {
      document.documentElement.setAttribute("dir", "rtl");
      document
        .getElementById(appRtlStyleId)
        .setAttribute("href", "/css/app-rtl.min.css");
      document
        .getElementById(bootstrapRtlStyleId)
        .setAttribute("href", "/css/bootstrap-rtl.min.css");
    } else {
      document.documentElement.setAttribute("dir", "ltr");
      document.getElementById(appRtlStyleId).removeAttribute("href");
      document.getElementById(bootstrapRtlStyleId).removeAttribute("href");
    }

    state.lang = lang;
  },
};

export const actions = {
  init({ commit, state }) {
    if (state.csrf) return;

    return WestoreAuth.CSRF().then(() => commit("SET_CSRF", true));
  },
  // eslint-disable-next-line no-unused-vars
  register({ commit, dispatch, getters }, data) {
    if (getters.authenticated) return Promise.resolve(null);
    return WestoreAuth.Register(data).then(({ data }) => {
      const user = data.data;
      commit("SET_USER", user);
      commit("SET_META", data.meta);
      return user;
    });
  },
  // eslint-disable-next-line no-unused-vars
  login({ commit, getters, dispatch }, credentials) {
    if (getters.authenticated) return Promise.resolve(null);

    return WestoreAuth.Login(credentials).then(({ data }) => {
      const user = data.data;
      dispatch("changeLang", user.locale);
      commit("SET_USER", user);
      commit("SET_META", data.meta);
      return user;
    });
  },
  logout({ commit, getters }) {
    return WestoreAuth.WithCredentials(getters.bearer_token)
      .Logout()
      .then(() => {
        commit("SET_USER", null);
        localStorage.removeItem("user");
        location.reload();
        return Promise.resolve(true);
      });
  },
  // eslint-disable-next-line no-unused-vars
  forgotPassword(context, { email }) {
    return WestoreAuth.ForgotPassword(email);
  },
  // eslint-disable-next-line no-unused-vars
  resetPassword(context, { token, payload }) {
    return WestoreAuth.ResetPassword(token, payload);
  },
  // eslint-disable-next-line no-unused-vars
  validate({ commit, dispatch, getters, state }) {
    return WestoreAuth.WithCredentials(getters.bearer_token)
      .Validate()
      .then(() => {
        if (!state.user) {
          WestoreAuth.User().then((user) => {
            commit("SET_USER", user);
          });
        }
        return state.user.token;
      })
      .catch((err) => {
        if ("response" in err && err.response.status === 401) {
          dispatch("terminate");
        }
      });
  },
  ValidateUserPermissions({ commit, state }) {
    return WestoreAuth.ValidateUserPermissions()
      .then(({ data }) => {
        const { contracted, domestic, international,storage,freight } = data.data;
        commit("SET_USER", { ...state.user, contracted,freight });
        commit("SET_META", {
          ...state.meta,
          services: { domestic, international,storage },
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  },
  terminate({ commit }) {
    commit("SET_USER", null);
    commit("SET_META", null);
    return router.push({ name: "login" });
  },
  changeLang({ commit, state }, lang) {
    i18n.locale = lang;
    const bootstrapRtlStyleId = "bootstrap-style";
    const appRtlStyleId = "app-style";
    if (["ar"].includes(lang)) {
      document.documentElement.setAttribute("dir", "rtl");
      document
        .getElementById(appRtlStyleId)
        .setAttribute("href", "/css/app-rtl.min.css");
      document
        .getElementById(bootstrapRtlStyleId)
        .setAttribute("href", "/css/bootstrap-rtl.min.css");
    } else {
      document.documentElement.setAttribute("dir", "ltr");
      document.getElementById(appRtlStyleId).removeAttribute("href");
      document.getElementById(bootstrapRtlStyleId).removeAttribute("href");
    }

    commit("SET_USER", { ...state.user, locale: lang });
  },
};

// const session = {
//     get(key) {
//         return sessionStorage.getItem(key)
//     },
//     set(key, value) {
//         sessionStorage.setItem(key, value);
//     },
//     remove(key) {
//         sessionStorage.removeItem(key);
//     }
// }
